<template>
  <div class="text-center">
    <div>
      {{ $t("personList.notFound1") }}
    </div>
    <div>
      {{
        $t("personList.notFound2", {
          professionName: professionName,
        })
      }}
      <NuxtLink :to="localePath({ name: 'registrationPage' })">{{
        $t("personList.notFound3")
      }}</NuxtLink>
      {{ $t("personList.notFound4") }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    professionName: {
      type: String,
      required: true,
    },
  },
  computed: {
    topDomain() {
      return this.$helpers.topDomain;
    },
  },
};
</script>
